import React, { useState } from 'react';
import { 
  Box, 
  TextField, 
  Button, 
  Paper, 
  Typography, 
  Chip, 
  CircularProgress 
} from '@mui/material';

interface SearchCommandInputProps {
  onExecute: (command: string) => void;
  isProcessing: boolean;
}

const SearchCommandInput: React.FC<SearchCommandInputProps> = ({ onExecute, isProcessing }) => {
  const [command, setCommand] = useState('');

  const handleExecute = () => {
    if (command.trim() && !isProcessing) {
      onExecute(command);
    }
  };

  // Example commands for search
  const exampleCommands = [
    'Find songs by The Beatles',
    'Search for jazz playlists',
    'Find albums about love',
    'Search for artists similar to Adele',
    'Find workout music',
    'Search for 80s rock songs'
  ];

  return (
    <Paper sx={{ p: 2, mb: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
        <TextField
          fullWidth
          label="Ask Otto to search for music"
          variant="outlined"
          value={command}
          onChange={(e) => setCommand(e.target.value)}
          placeholder="e.g., Find songs by The Beatles, Search for jazz playlists"
          multiline
          rows={2}
          disabled={isProcessing}
          sx={{ mr: 2 }}
        />
        <Button
          variant="contained"
          onClick={handleExecute}
          disabled={!command.trim() || isProcessing}
          sx={{ height: '56px', minWidth: '100px' }}
        >
          {isProcessing ? <CircularProgress size={24} /> : 'Search'}
        </Button>
      </Box>
      
      <Box sx={{ mt: 2 }}>
        <Typography variant="subtitle2" gutterBottom>
          Try asking Otto:
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {exampleCommands.map((cmd, index) => (
            <Chip 
              key={index} 
              label={cmd} 
              onClick={() => setCommand(cmd)} 
              clickable
              color="primary"
              variant="outlined"
            />
          ))}
        </Box>
      </Box>
    </Paper>
  );
};

export default SearchCommandInput;
